export enum RISKLEVEL {
  LOW=1, // 低
  MIDDLE = 2, // 中
  HIGH = 3, // 高

}
